export const DO_THING = 'common/DO_THING';
